import { dew as _generated2Dew } from "../builders/generated";
import { dew as _2Dew } from "..";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = prependToMemberExpression;
  var _generated = _generated2Dew();
  var _ = _2Dew();
  function prependToMemberExpression(member, prepend) {
    if ((0, _.isSuper)(member.object)) {
      throw new Error("Cannot prepend node to super property access (`super.foo`).");
    }
    member.object = (0, _generated.memberExpression)(prepend, member.object);
    return member;
  }

  //# sourceMappingURL=prependToMemberExpression.js.map
  return exports;
}